import React, { useState } from "react";
import axios from "axios";
import ReactCompareImage from "react-compare-image";
import "bootstrap/dist/css/bootstrap.min.css";

function ImageTool() {
  const [files, setFiles] = useState([]);
  const [logo, setLogo] = useState(null);
  const [previews, setPreviews] = useState([]);
  const [sessionId, setSessionId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [positionPreset, setPositionPreset] = useState("custom");
  const [watermarkText, setWatermarkText] = useState("");
  const [watermarkColor, setWatermarkColor] = useState("#ffffff");
  const [fontSize, setFontSize] = useState(24);
  const [fontFamily, setFontFamily] = useState("Arial");
  const [bold, setBold] = useState(false);
  const [opacity, setOpacity] = useState(0.7);
  const [watermarkX, setWatermarkX] = useState(0);
  const [watermarkY, setWatermarkY] = useState(0);
  const [format, setFormat] = useState("jpeg");
  const [brightness, setBrightness] = useState(1);
  const [contrast, setContrast] = useState(1);
  const [sharpen, setSharpen] = useState(1);

  const handlePreview = async () => {
    if (files.length === 0) return alert("Upload images first");

    const formData = new FormData();
    files.forEach((file) => formData.append("images", file));

    formData.append("format", format);
    formData.append("brightness", brightness);
    formData.append("contrast", contrast);
    formData.append("sharpen", sharpen);
    formData.append("positionPreset", positionPreset);
    formData.append("watermarkText", watermarkText);
    formData.append("watermarkColor", watermarkColor);
    formData.append("fontSize", fontSize);
    formData.append("fontFamily", fontFamily);
    formData.append("bold", bold);
    formData.append("opacity", opacity);
    formData.append("watermarkX", watermarkX);
    formData.append("watermarkY", watermarkY);

    if (logo) formData.append("logo", logo);

    try {
      setLoading(true);
      const response = await axios.post(
        "https://darkgoldenrod-bee-402758.hostingersite.com/api/images/preview",
        formData
      );

      setPreviews(response.data.previews);
      setSessionId(response.data.sessionId);
    } catch (err) {
      alert("Processing failed");
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    window.open(
      `https://darkgoldenrod-bee-402758.hostingersite.com/api/images/download/${sessionId}`,
      "_blank"
    );
  };

  return (
    <>
      {/* NAVBAR */}
      <nav className="navbar navbar-dark bg-dark px-4">
        <span className="navbar-brand mb-0 h1">
          Image Processing Dashboard
        </span>
      </nav>

      <div className="container-fluid mt-4">
        <div className="row">

          {/* LEFT SIDEBAR */}
          <div className="col-lg-4">
            <div className="card shadow-sm mb-4">
              <div className="card-body">
                <h5 className="card-title mb-3">Upload Images</h5>

                <input
                  type="file"
                  multiple
                  className="form-control mb-3"
                  accept="image/*"
                  onChange={(e) => setFiles([...e.target.files])}
                />

                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => setLogo(e.target.files[0])}
                />
                <small className="text-muted">Optional Logo Upload</small>
              </div>
            </div>

            {/* WATERMARK SETTINGS */}
            <div className="card shadow-sm mb-4">
  <div className="card-body">
    <h5 className="card-title mb-3">Watermark Settings</h5>

    {/* Watermark Text */}
    <input
      type="text"
      className="form-control mb-3"
      placeholder="Watermark Text"
      value={watermarkText}
      onChange={(e) => setWatermarkText(e.target.value)}
    />

    {/* Color + Font Size */}
    <div className="row mb-3">
      <div className="col-6">
        <label className="form-label">Color</label>
        <input
          type="color"
          className="form-control form-control-color w-100"
          value={watermarkColor}
          onChange={(e) => setWatermarkColor(e.target.value)}
        />
      </div>

      <div className="col-6">
        <label className="form-label">Font Size</label>
        <input
          type="number"
          className="form-control"
          value={fontSize}
          onChange={(e) => setFontSize(Number(e.target.value))}
        />
      </div>
    </div>

    {/* Font Family */}
    <label className="form-label">Font Family</label>
    <select
      className="form-select mb-3"
      value={fontFamily}
      onChange={(e) => setFontFamily(e.target.value)}
    >
      <option value="Arial">Arial</option>
      <option value="Verdana">Verdana</option>
      <option value="Courier New">Courier New</option>
      <option value="Georgia">Georgia</option>
    </select>

    {/* Bold */}
    <div className="form-check mb-3">
      <input
        type="checkbox"
        className="form-check-input"
        checked={bold}
        onChange={(e) => setBold(e.target.checked)}
      />
      <label className="form-check-label">Bold</label>
    </div>

    {/* Opacity */}
    <label className="form-label">Opacity</label>
    <input
      type="range"
      className="form-range mb-3"
      min="0.1"
      max="1"
      step="0.1"
      value={opacity}
      onChange={(e) => setOpacity(Number(e.target.value))}
    />

    {/* Position Preset Dropdown */}
    <label className="form-label">Watermark Position</label>
    <select
      className="form-select mb-3"
      value={positionPreset}
      onChange={(e) => setPositionPreset(e.target.value)}
    >
      <option value="custom">Custom (Manual X/Y)</option>
      <option value="top-left">Top Left</option>
      <option value="top-center">Top Center</option>
      <option value="top-right">Top Right</option>
      <option value="center-left">Center Left</option>
      <option value="center">Center</option>
      <option value="center-right">Center Right</option>
      <option value="bottom-left">Bottom Left</option>
      <option value="bottom-center">Bottom Center</option>
      <option value="bottom-right">Bottom Right</option>
      <option value="diagonal-1">Diagonal (↘ TL → BR)</option>
      <option value="diagonal-2">Diagonal (↗ BL → TR)</option>
    </select>

    {/* Custom X/Y Only If Selected */}
    {positionPreset === "custom" && (
      <div className="row">
        <div className="col-6">
          <label className="form-label">X Position</label>
          <input
            type="number"
            className="form-control"
            value={watermarkX}
            onChange={(e) => setWatermarkX(Number(e.target.value))}
          />
        </div>

        <div className="col-6">
          <label className="form-label">Y Position</label>
          <input
            type="number"
            className="form-control"
            value={watermarkY}
            onChange={(e) => setWatermarkY(Number(e.target.value))}
          />
        </div>

        <small className="text-muted mt-2">
          Enter pixel position manually
        </small>
      </div>
    )}
  </div>
</div>

            {/* ADJUSTMENTS */}
            <div className="card shadow-sm mb-4">
              <div className="card-body">
                <h5 className="card-title mb-3">Image Adjustments</h5>

                <label>Brightness</label>
                <input
                  type="range"
                  className="form-range"
                  min="0.5"
                  max="2"
                  step="0.1"
                  value={brightness}
                  onChange={(e) => setBrightness(Number(e.target.value))}
                />

                <label>Contrast</label>
                <input
                  type="range"
                  className="form-range"
                  min="0.5"
                  max="2"
                  step="0.1"
                  value={contrast}
                  onChange={(e) => setContrast(Number(e.target.value))}
                />

                <label>Sharpen</label>
                <input
                  type="range"
                  className="form-range"
                  min="0"
                  max="5"
                  step="0.5"
                  value={sharpen}
                  onChange={(e) => setSharpen(Number(e.target.value))}
                />

                <select
                  className="form-select mt-3"
                  value={format}
                  onChange={(e) => setFormat(e.target.value)}
                >
                  <option value="jpeg">JPEG</option>
                  <option value="png">PNG</option>
                  <option value="webp">WEBP</option>
                </select>
              </div>
            </div>

            <button
              className="btn btn-primary w-100 mb-5"
              onClick={handlePreview}
            >
              {loading ? "Processing..." : "Generate Preview"}
            </button>
          </div>

          {/* RIGHT PREVIEW PANEL */}
          <div className="col-lg-8">
            <div className="card shadow-sm">
              <div className="card-body">
                <h4 className="mb-4">Preview Panel</h4>

                <div className="row">
                  {previews.map((img, i) => (
                    <div key={i} className="col-md-6 mb-4">
                      <div className="border rounded p-2">
                        <ReactCompareImage
                          leftImage={URL.createObjectURL(files[i])}
                          rightImage={img.base64}
                        />
                      </div>
                    </div>
                  ))}
                </div>

                {sessionId && (
                  <button
                    className="btn btn-success mt-3"
                    onClick={handleDownload}
                  >
                    Download All Images
                  </button>
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default ImageTool;